import { createSlice } from '@reduxjs/toolkit';
// utils
import axios from '../../utils/axios';
//
import { dispatch } from '../store';

// ----------------------------------------------------------------------
  const initialState = {
    isLoading: false,
    error: null,
    productXmlList: [],
    totalItems: 0,
    ItemsOnPage: 0
  };

  const slice = createSlice({
    name: 'productXml',
    initialState,
    reducers: {
      // START LOADING
      startLoading(state) {
        state.isLoading = true;
      },
  
      // HAS ERROR
      hasError(state, action) {
        state.isLoading = false;
        state.error = action.payload;
      },
    
      getProductXmlSuccess(state, action) {
        state.isLoading = false;
        state.productXmlList = action.payload;
      },
      
      getProductXmlSuccess2(state, action) {
        state.isLoading = false;
        state.productXmlList = action.payload.items;
        state.totalItems = action.payload.totalItems;
        state.ItemsOnPage = action.payload.ItemsOnPage;
      },
  
      addProductXmlSuccess(state, action) {
        const data = action.payload; 
        state.isLoading = false;
      },

    },
  });
  
  // Reducer
  export default slice.reducer;
  

  
  // ----------------------------------------------------------------------
  
  export function getProductXmlPagination(data) {
    return async () => {
      dispatch(slice.actions.startLoading());
      try {
        const response = await axios.get('/api/productXmlProfile/pagination/all', {
          params: {
            ...data
          }
        });
        dispatch(slice.actions.getProductXmlSuccess2(response.data));
      } catch (error) {
        dispatch(slice.actions.hasError(error));
      }
    };
  };

  export function getProductXml() {
    return async () => {
      dispatch(slice.actions.startLoading());
      try {
        const response = await axios.get('/api/productXmlProfile');
        dispatch(slice.actions.getProductXmlSuccess(response.data));
      } catch (error) {
        dispatch(slice.actions.hasError(error));
      }
    };
  };

  export function deleteProductXml(id) {
    return async (dispatch) => {
      dispatch(slice.actions.startLoading());
      try {
        const response = await axios.put(`/api/productXmlProfile/delete/${id}`);
        dispatch(slice.actions.addProductXmlSuccess(response.data.event));
        return { payload: {} };
      } catch (error) {
        console.log('error')
        const errorMessage = error.response?.data?.message || error.response?.data?.error || error.message || 'An error occurred';
        dispatch(slice.actions.hasError(error));
        return { status: "error", message: errorMessage };
      }
    };
  }

  export function addProductXml(data) {
    return async (dispatch) => {
      dispatch(slice.actions.startLoading());
      try {
        const response = await axios.post('/api/productXmlProfile/add', data);
        dispatch(slice.actions.addProductXmlSuccess(response.data.event));
        return { payload: {} };
      } catch (error) {
        console.log('error')
        const errorMessage = error.response?.data?.message || error.response?.data?.error || error.message || 'An error occurred';
        dispatch(slice.actions.hasError(error));
        return { payload: { error: errorMessage } };
      }
    };
  }

  export function updateProductXml(id,data) {
    return async (dispatch) => {
      dispatch(slice.actions.startLoading());
      try {
        const response = await axios.put(`/api/productXmlProfile/update/${id}`, data);
        dispatch(slice.actions.addProductXmlSuccess(response.data.event));
        return { payload: {} };
      } catch (error) {
        console.log('error')
        const errorMessage = error.response?.data?.message || error.response?.data?.error || error.message || 'An error occurred';
        dispatch(slice.actions.hasError(error));
        return { payload: { error: errorMessage } };
      }
    };
  }
  



  


 
  